export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apri disputa"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un moderatore si unirà per assistere. Seleziona un motivo e allega le prove."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia al moderatore"])}
}